import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { DashboardQueryParams, DashboardResponse } from '../models/dashboard.model';

/**
 * Reads the portfolio panel. Pure read: never recomputes VCR, never reconsults
 * the bureau, never settles anything — the "Atualizar" action is just a fresh
 * call to this same route.
 */
@Injectable({ providedIn: 'root' })
export class DashboardApiService {
  private readonly http = inject(HttpClient);

  private readonly epDashboard = `${environment.apiBaseUrl}dashboard`;

  getDashboard(params?: DashboardQueryParams): Observable<DashboardResponse> {
    return this.http.get<DashboardResponse>(this.epDashboard, {
      params: this.toHttpParams(params),
    });
  }

  private toHttpParams(params?: DashboardQueryParams): HttpParams | undefined {
    if (!params) {
      return undefined;
    }

    let httpParams = new HttpParams();

    if (params.compare_days !== undefined) {
      httpParams = httpParams.set('compare_days', String(params.compare_days));
    }
    if (params.top_exposures !== undefined) {
      httpParams = httpParams.set('top_exposures', String(params.top_exposures));
    }
    if (params.alerts !== undefined) {
      httpParams = httpParams.set('alerts', String(params.alerts));
    }

    return httpParams;
  }
}
